<template>

  <p id="a">{{ tweened.number.toFixed(0) }}</p>
</template>

<script>
import gsap from 'gsap'

export default {
  name: 'Contador',
  data() {
    return {
      // number: 0,
      tweened: {
        number: 0
      },
      telaY: (window.screen.height * 0.5),
      executaFunc: true,
    }
  },
  props: {
    number: Number,
    id_element: {
      default: null
    },
  },
  methods: {
    async conta() {
      var el = document.getElementById('a');
      var coordenadas = el.getBoundingClientRect();

      gsap.to(this.tweened, { duration: 2.5, number: Number(this.number) || 0 })
      // if (coordenadas.top < this.telaY) {
      // }
    }
  },
  mounted() {
    this.conta()
  },
  watch: {

    number(n) {
      gsap.to(this.tweened, { duration: 1.5, number: Number(n) || 0 })
    }
  },
}
</script>
